import { SimpleImage } from '@boss/types/b2b-b2c';
import { BrandFields, Nullable } from '@boss/types/corporate-jobs';

const getBrandCardProps = (
  entry: BrandFields,
): {
  logo: Nullable<SimpleImage>;
  link: string;
} => ({
  logo: {
    imageUrl: entry.logo.image.file.url,
    imageAlt: entry.logo.altText ?? entry.logo.image.title,
    id: entry.logo.id,
  },
  link: entry.link,
});

export default getBrandCardProps;
